import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const HasilUji = () => {
    const columns = [
        {
            name: 'ID Target',
            cell: row => row['idTarget']
        },
        {
            name: 'Target Uji',
            cell: row => row['targetUji'] 
        },
        {
            name: 'Jenis Uji',
            cell: row => row['jenisUji'] 
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])

    const [listHasilUji, setlistHasilUji] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistHasilUji = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await masterService.listHasilUji(null, null, page, size)
            setlistHasilUji(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistHasilUji([])
        }
        setLoading(false)
    }, [masterService])

    useEffect(() => {
        getlistHasilUji(0, 10)
    }, [getlistHasilUji])

    const handleChangePage = (page) => {
        getlistHasilUji(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await masterService.listHasilUji(null, null, page - 1, size)
        setlistHasilUji(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Hasil Uji</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                        <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listHasilUji}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );

}

export default HasilUji